import { FunctionComponent, useState } from "react";
import { useOnMount } from "@pjs/react-utilities";
import { a11yI18n } from "../i18n/A11yI18n.const";
import { IAction } from "./interfaces/IAction";
import { actionLogger } from "./consts/ActionLogger.const";
import "./styles/action-log.css";

export const ActionLog: FunctionComponent = () => {
    const [actions, setActions] = useState<ReadonlyArray<IAction>>([]);

    useOnMount(() => {
        const actionSubscription = actionLogger.observe().subscribe(setActions);

        return () => {
            actionSubscription.unsubscribe();
        };
    });

    return (
        <section
            className="aly-action-log__container"
            aria-label={a11yI18n.getPluralString("action_logger.heading", { count: Math.floor(actionLogger.actionExpiryTime / 1000 / 60) })}>
            <div role="log" aria-live="polite" aria-relevant="additions">
                <ul className="aly-action-log__list">
                    {actions.map((action) => {
                        return <li key={action.id}>{action.text}</li>;
                    })}
                </ul>
            </div>
        </section>
    );
};
